import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-help-info',
  templateUrl: './help-info.component.html',
  styleUrls: ['./help-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class HelpInfoComponent {
  // constructor() {}
}
